var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pwd-body" }, [
    _c("div", { staticClass: "countdown" }, [
      _c("svg", { attrs: { width: _vm.size, height: _vm.size } }, [
        _c("circle", {
          attrs: {
            fill: "transparent",
            "stroke-width": _vm.stroke,
            stroke: "#270B58",
            r: _vm.radius,
            cx: _vm.circleOffset,
            cy: _vm.circleOffset,
          },
        }),
        _c("circle", {
          staticClass: "circle",
          attrs: {
            fill: "transparent",
            "stroke-width": _vm.stroke,
            stroke: "#F36F21",
            r: _vm.radius,
            cx: _vm.circleOffset,
            cy: _vm.circleOffset,
            "stroke-dasharray": _vm.circumference,
            "stroke-dashoffset": _vm.progress,
            "stroke-linecap": "round",
          },
        }),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.countdown))]),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("链接无效 即将跳转登录页面")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }